export const combinationId = ({ category, groups }) =>
  '!' + (category ?? '') + ' ' +
  (groups ?? [])
    .map(group => '@' + group)
    .join(' ')
